import React, {
 useState, useContext, useEffect, useRef, 
} from 'react';
import { Col } from 'react-bootstrap';
import {
  Card, CardBody, CardTitleWrap, CardSubhead,
} from '@/shared/components/Card';
import Select from 'react-select';
import CryptoJS from 'crypto-js';
import { Button } from '@/shared/components/Button';
import { Table } from '@/shared/components/TableElements';
import toast from 'react-hot-toast';
import { Checkbox } from '@mui/material';
import { AuthContext } from '../../../../context/AuthContext';
import { PermissionContext } from '../../../../context/PermissionContext';




const Manager = () => {
  const { userid, apiGlobal, countryid } = useContext(AuthContext);
  const { setPermissionUpdate, setPermissionsAccess } = useContext(PermissionContext);
  const [userName, setUserName] = useState([]);
  const [userId, setUserId] = useState('');
  const [modules, setModules] = useState(['agent',
     'restaurant', 'meal', 'booking', 'payment', 'trip', 'restaurant account', 'day book']);
  const [permissions, setPermissions] = useState({});

  const checkboxRef = useRef(null);

  // const PermissionsAccess = async () => {
  //   const response = await fetch(`${apiGlobal}admin_permission?id=${userid}`);
  //   const data = await response.json();
  //   // console.log(data);
  // };
  
  // useEffect(() => {
  //   PermissionsAccess();
  // }, []);


  useEffect(() => {
    const newPermissions = {};

    modules.forEach((module) => {
      newPermissions[module] = {
        view: false,
        create: false,
        edit: false,
        delete: false,
        approval: false,
      };
    });
    setPermissions(newPermissions);
  }, [modules]);

  const permissionColors = {
    view: '#007bff',
    create: '#28a745',
    edit: '#ffc107',
    delete: '#dc3545',
    approval: '#c133ff',
  };

  const fetchPermissions = async () => {
    const formData = new FormData();
    formData.append('id', userid);
    formData.append('country_id', countryid);
    try {
      const response = await fetch(`${apiGlobal}/admin_permission.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();

      const secretKey = 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2';
 
      // console.log('Fetched Permissions:', data);
      if (data?.status && data?.message === 'Success') {
        const permissionss = data?.data[0]?.permission || {};
        setPermissionsAccess(permissionss);
        const permissionsString = CryptoJS.AES.encrypt(JSON.stringify(permissionss), secretKey).toString();
        localStorage.setItem('permissions', permissionsString);
        // console.log('fetch permisssion function called');
      } else {
        setPermissionsAccess([]);
        localStorage.removeItem('permissions');
      }
    } catch (error) {
      console.error('Error fetching permissions:', error);
      setPermissionsAccess([]);
      localStorage.removeItem('permissions');
    }
  };


  const fetchUser = async () => {
    const formData = new FormData();
    formData.append('country_id', countryid);
    try {
      const response = await fetch(`${apiGlobal}/user_admin_data.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data.status && data.message === 'Success') {
        setUserName(data.data.map(user => ({ label: user.name, value: user.id })));
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

//   const handleCheckboxChange = (module, permission) => {
//     console.log(module, permission); // agent /view 
// console.log(checkboxRef.current);
//     setPermissions(prev => ({
//       ...prev,
//       [module]: {
//         ...prev[module],
//         [permission]: !prev[module][permission],
//       },
//     }));
//   };

const handleCheckboxChange = (module, permission) => {
  setPermissions((prev) => {
    // If changing the view permission
    if (permission === 'view') {
      // Toggle view permission
      const newViewValue = !prev[module][permission];
      
      // If unchecking view, uncheck all other permissions
      if (!newViewValue) {
        return {
          ...prev,
          [module]: {
            view: false,
            create: false,
            edit: false,
            delete: false,
            approval: false,
          },
        };
      }
      
      // If checking view, return updated view permission
      return {
        ...prev,
        [module]: {
          ...prev[module],
          view: newViewValue,
        },
      };
    }
    
    // For other permissions (create, edit, delete)
    // Only allow changes if view is true
    if (!prev[module].view) {
      return prev;
    }
    
    // Toggle other permissions
    return {
      ...prev,
      [module]: {
        ...prev[module],
        [permission]: !prev[module][permission],
      },
    };
  });
};

  // useEffect(() => {
  //   // console.log('Permissions:', permissions);
  // }, [permissions]);

  const fetchUserPermissions = async (e) => {
    setUserId(e.value);
    let fetchedPermissions = [];
    const newPermissions = {};
     const formData = new FormData();
     formData.append('user_id', e.value);
    formData.append('country_id', countryid);
    try {
      const url = `${apiGlobal}/admin_get_role.php`;
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      // console.log(data);
  
      if (data.status && data.message === 'Success') {
        fetchedPermissions = data.permissions || [];
  
        // Initialize permissions for each module
        modules.forEach((module) => {
          newPermissions[module] = {
            view: fetchedPermissions.includes(`view_${module}`),
            create: fetchedPermissions.includes(`create_${module}`),
            edit: fetchedPermissions.includes(`edit_${module}`),
            delete: fetchedPermissions.includes(`delete_${module}`),
            approval: fetchedPermissions.includes(`approval_${module}`),

          };
        });
      } else {
        toast.error(data.message || 'Failed to fetch permissions');
        // Default permissions when fetching fails or no success message
        modules.forEach((module) => {
          newPermissions[module] = {
            view: false,
            create: false,
            edit: false,
            delete: false,
            approval: false,
          };
        });
      }
  
      setPermissions(newPermissions);
    } catch (error) {
      console.error('Error fetching permissions:', error);
      // Set default permissions in case of error
      modules.forEach((module) => {
        newPermissions[module] = {
          view: false,
          create: false,
          edit: false,
          delete: false,
          approval: false,
        };
      });
      setPermissions(newPermissions);
    }
  };
  
  const handleSelectAll = (e) => {
    const { checked } = e.target;
    const newPermissions = {};
     if (checked) {
      modules.forEach((module) => {
        newPermissions[module] = {
          view: true,
          create: true,
          edit: true,
          delete: true,
          approval: true,
        };
      });
      setPermissions(newPermissions);
     } else if (!checked) {
      modules.forEach((module) => {
        newPermissions[module] = {
          view: false,
          create: false,
          edit: false,
          delete: false,
          approval: false,
        };
      });
      setPermissions(newPermissions);
     }
  };

  
  // const fetchUserPermissions = async (e) => {
  //   setUserId(e.value);
  //   try {
  //     const url = `${apiGlobal}/admin_get_role.php?user_id=${e.value}`;
  //     const response = await fetch(url);
  //     const data = await response.json();
  //     console.log(data);
  //     if (data.status && data.message === 'Success') {
  //       const fetchedPermissions = data.permissions;
  //       // console.log('Fetched permissions:', fetchedPermissions);
  //       const newPermissions = {};
  //       if (fetchedPermissions) {
  //         modules.forEach((module) => {
  //           newPermissions[module] = {
  //             view: fetchedPermissions.includes(`view_${module}`) || false,
  //             create: fetchedPermissions.includes(`create_${module}`) || false,
  //             edit: fetchedPermissions.includes(`edit_${module}`) || false,
  //             delete: fetchedPermissions.includes(`delete_${module}`) || false,
  //           };
  //         });
  //       } else {
  //         modules.forEach((module) => {
  //           newPermissions[module] = {
  //             view: false,
  //             create: false,
  //             edit: false,
  //             delete: false,
  //           };
  //         });
  //       }
        

  //       setPermissions(newPermissions);
  //     } else {
  //       toast.error(data.message);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  

  const saveUserPermissions = async () => {
    // console.log(userId);
    try {
      if (!userId) {
        console.error('User not selected');
        return;
      }
  
      const formData = new FormData();
      formData.append('user_id', userId);
  
      const permissionsObject = {
        view: {},
        create: {},
        edit: {},
        delete: {},
        approval: {},
      };
  
      modules.forEach((module) => {
        Object.keys(permissions[module]).forEach((permission) => {
          const normalizedPermission = permission.trim().replace(/\s+/g, '_'); // convert "view admin" → "view_admin"
      
          if (!permissionsObject[normalizedPermission]) {
            permissionsObject[normalizedPermission] = {};
          }
      
          permissionsObject[normalizedPermission][module] = permissions[module][permission];
        });
      });
      
      console.log(JSON.stringify(permissionsObject));
  
      // Append permissions as a JSON string
      formData.append('permissions', JSON.stringify(permissionsObject));
  
    //   // Print FormData for debugging purposes
    // Array.from(formData.entries()).forEach(([key, value]) => {
    //     console.log(`${key}: ${value}`);
    //   });
      
  
      // Send the form data to the backend
      const response = await fetch(`${apiGlobal}/admin_role.php`, {
        method: 'POST',
        body: formData,
      });
  
      const data = await response.json();
  
      if (data.status && data.message === 'Permissions updated successfully.') {
        toast.success('Permissions updated successfully!');
        fetchPermissions();
        setPermissionUpdate(prev => !prev);
      } else {
        toast.error(data.message || 'An error occurred while updating permissions.');
      }
    } catch (error) {
      console.error('Error saving user permissions:', error);
    }
  };

 
  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <CardSubhead>
              All Users <span className="red-text">Bitevize-Admin</span>
            </CardSubhead>
            <Select
              name="userid"
              className="react-select w-25 mt-4"
              classNamePrefix="react-select"
              options={userName}
              placeholder="Select a User"
              onChange={e => fetchUserPermissions(e)}
            />
          </CardTitleWrap>
          <div style={{
  display: 'flex',
  alignItems: 'center', // Vertically aligns the checkbox and the text
  gap: '5px', // Adds a small gap between the checkbox and text
}}
          >
            <Checkbox onChange={e => handleSelectAll(e)} disabled={!userId} />
            <p style={{ margin: 0 }}>Select All Permission</p>  {/* Ensure there's no extra margin on the text */}
          </div>


          <Table responsive bordered>
            <thead>
              <tr>
                <th>Permission Name</th>
                <th style={{ color: '#007bff' }}>View</th>
                <th style={{ color: '#28a745' }}>Create</th>
                <th style={{ color: '#ffc107' }}>Edit</th>
                <th style={{ color: '#dc3545' }}>Delete</th>
                <th style={{ color: '#c133ff' }}>Approval</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(permissions).map(module => (
                <tr key={module}>
                  <th>{module.charAt(0).toUpperCase() + module.slice(1)}</th>
                  {Object.keys(permissions[module]).map(permission => (
        // Hide approval checkbox for trip module
        ((module === 'booking' && permission === 'approval') 
        || (module === 'trip' && permission === 'approval') 
        || (module === 'restaurant account' && permission === 'approval')
        || (module === 'day book' && permission === 'approval')
        || (module === 'currency' && permission === 'approval')
      ) ? null : (
        <td key={permission}>
          <input
            type="checkbox"
            checked={permissions[module][permission]}
            onChange={() => handleCheckboxChange(module, permission)}
            disabled={((permission !== 'view') && !permissions[module].view) || !userId}
            ref={checkboxRef}
            style={{
                width: '20px',
                height: '20px',
                accentColor: permissionColors[permission] || '#6c757d',
                cursor: (permission !== 'view' && !permissions[module].view) || !userId ? 'not-allowed' : 'pointer',
              }}
          />
        </td>
        )
      ))}
                </tr>
  ))}
            </tbody>


          </Table>
          <Button
            style={{ float: 'right', marginTop: '10px' }}
            variant="success"
            size="sm"
            onClick={() => saveUserPermissions()}
          >
            Update Permission
          </Button>
        </CardBody>
      </Card>
    </Col>
  );
};

export default React.memo(Manager);
